import {createRouter, createWebHashHistory} from 'vue-router';
import Index from '../views/index/index.vue';
import Login from '../views/Login.vue';
import SSOLogin from '../views/SSOLogin.vue';
import Register from '../views/Register.vue';
import InviteRegister from '../views/InviteRegister.vue';
import PaySuccess from '../views/PaySuccess.vue';
import Forgot from '../views/Forgot.vue';
import Error from '../views/Error.vue';
import ForgotNotice from '../views/ForgotNotice.vue';
import PasswordReset from '../views/PasswordReset.vue';
import PasswordResetNotice from '../views/PasswordResetNotice.vue';
import RegisterNotice from '../views/RegisterNotice.vue';
import RegisterVerify from '../views/RegisterVerify.vue';
import ExternalLoginVerify from '../views/external/ExternalLoginVerify.vue';
import {DEFAULT_PORTAL, setConfig} from '@/glue';
import {user} from './user';
import {showConfirm} from '@/components';
import {useLanguage} from '@front/hooks';
import Downloads from "@front/views/Downloads.vue";
import Guest from "@front/views/Guest.vue";
import InviteDownloads from "@front/views/InviteDownloads.vue";

setConfig({
  DEFAULT_PORTAL: '/user/profile',
});

export const routes = [
  {
    path: '/',
    name: 'index',
    redirect: DEFAULT_PORTAL,
    component: Index,
    children: [user],
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/ssoLogin',
    name: 'ssoLogin',
    component: SSOLogin,
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
  },
  {
    path: '/inviteRegister',
    name: 'inviteRegister',
    component: InviteRegister,
  },
  {
    path: '/inviteDownloads/:username',
    name: 'inviteDownloads',
    component: InviteDownloads,
  },
  {
      path: '/pay/success',
      name: 'paySuccess',
      component: PaySuccess,
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: Forgot,
  },
  {
    path: '/forgotNotice',
    name: 'forgotNotice',
    component: ForgotNotice,
  },
  {
    path: '/passwordReset/:username/:type',
    name: 'passwordReset',
    component: PasswordReset,
  },
  {
    path: '/passwordResetNotice',
    name: 'passwordResetNotice',
    component: PasswordResetNotice,
  },
  // {
  //   path: '/passwordReset/:code/:launchScheme',
  //   name: 'passwordReset',
  //   component: PasswordReset,
  // },
  // {
  //   path: '/passwordResetNotice/:launchScheme',
  //   name: 'passwordResetNotice',
  //   component: PasswordResetNotice,
  // },
  {
    path: '/registerNotice',
    name: 'registerNotice',
    component: RegisterNotice,
  },
  // {
  //   path: '/registerVerify/:code/:launchScheme',
  //   name: 'registerVerify',
  //   component: RegisterVerify,
  // },
  {
    path: '/registerVerify/:username/:type',
    name: 'registerVerify',
    component: RegisterVerify,
  },
  {
    path: '/externalLoginVerify',
    name: 'externalLoginVerify',
    component: ExternalLoginVerify,
  },
  {
    path: '/downloads',
    name: 'downloads',
    component: Downloads,
  },
  {
    path: '/guest',
    name: 'guest',
    component: Guest,
  },
  {
    path: '/error',
    name: 'error',
    component: Error,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: DEFAULT_PORTAL,
  },
];

if (import.meta.env.MODE === 'local_dev') {
  routes[0].children[0].children.push({
    path: 'demo',
    name: 'menu.user.demo',
    component: () => import('../views/index/user/Demo.vue'),
  });
}

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeResolve((to, from, next) => {
  if (to.path === '/user/withdrawIndex' && (!to.query?.activeName || !['withdraw', 'bank_card'].includes(to.query?.activeName))) {
    const activeName = from.name === 'menu.user.withdraw' ? from.query.activeName : 'withdraw';
    const lang = to.query.lang;
    const wv = to.query.wv;
    let targetPath = `/user/withdrawIndex?activeName=${activeName}`;
    if (wv && lang) targetPath += `&wv=${wv}&lang=${lang}`;
    next(targetPath);
  } else next();
});

router.onError((err = {}) => {
  if (err.name === 'TypeError' && err.message.startsWith('Failed to fetch dynamically imported module')) {
    const { t, PREFIX } = useLanguage();
    showConfirm({
      title: t('resourceNotFoundTitle', PREFIX.CONFIRM),
      content: t('resourceNotFoundContent', PREFIX.CONFIRM),
      onOk() {
        window.location.reload();
      },
    });
  }
});

export default router;
